import React, { createContext, useContext, useState, ReactNode } from 'react';

export type WorkspaceMode = 'ATUAL' | 'KAIZEN' | 'FUTURO';

interface WorkspaceModeContextType {
  mode: WorkspaceMode;
  setMode: (mode: WorkspaceMode) => void;
}

const WorkspaceModeContext = createContext<WorkspaceModeContextType | undefined>(undefined);

interface WorkspaceModeProviderProps {
  children: ReactNode;
}

export const WorkspaceModeProvider: React.FC<WorkspaceModeProviderProps> = ({ children }) => {
  const [mode, setMode] = useState<WorkspaceMode>('ATUAL');

  return (
    <WorkspaceModeContext.Provider value={{ mode, setMode }}>
      {children}
    </WorkspaceModeContext.Provider>
  );
};

export const useWorkspaceMode = (): WorkspaceModeContextType => {
  const context = useContext(WorkspaceModeContext);
  if (!context) {
    throw new Error('useWorkspaceMode must be used within WorkspaceModeProvider');
  }
  return context;
};
